// extracted by css-extract-rspack-plugin
export default {"details":"wLUq5iyUcm4qMWY1","detailItem":"OY1mhwNJY8IxlsYE","detailValue":"q9RzuG5z08jr1aUN","resourceReference":"OumgeKE0KJkDsXAf"};